var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "email-form"
  }, [_c("email", {
    ref: "emailForm",
    attrs: {
      item: _vm.copyItem,
      attachmentVariable: _vm.attachmentVariable,
      variables: _vm.variables,
      isEdit: _vm.isEdit
    }
  }), _c("variable", {
    staticStyle: {
      width: "30%"
    },
    attrs: {
      variables: _vm.variables
    }
  }), _c("div", {
    staticClass: "btnhandles"
  }, [_vm.btnShow === 1 || _vm.isEdit === true ? _c("a-button", {
    attrs: {
      type: "primary",
      loading: _vm.loading
    },
    on: {
      click: _vm.saveForm
    }
  }, [_vm._v(_vm._s(_vm.$t("保存")))]) : _vm._e(), _vm.btnShow === 2 && _vm.isEdit === false ? _c("a-button", {
    attrs: {
      type: "edit"
    },
    on: {
      click: _vm.editForm
    }
  }, [_vm._v(_vm._s(_vm.$t("编辑")))]) : _vm._e(), _vm.btnShow === 3 && _vm.isEdit === true ? _c("a-button", {
    attrs: {
      loading: _vm.loading
    },
    on: {
      click: _vm.cancelForm
    }
  }, [_vm._v(_vm._s(_vm.$t("取消")))]) : _vm._e()], 1), _c("preview-modal", {
    attrs: {
      visible: _vm.previewVisible,
      videoTypeList: ["mp4"],
      fileList: _vm.form.fileList,
      show: _vm.fileType,
      src: _vm.previewSrc,
      currentIndex: _vm.currentPreviewIndex
    },
    on: {
      cancel: _vm.cancelPre
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };